// extracted by mini-css-extract-plugin
module.exports = {"root":"illustration__root--qUv3t"};